import React from 'react';

import Modal from '@material-ui/core/Modal';
import { Grid, Typography, Button, Link } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';

import { BACKGROUND_COLOR, COLOR_PRIMARY_DARK, COLOR_PRIMARY_LIGHT, DARK_GREY } from 'src/const';
import airbnb from '../../assets/airbnb.svg';
import logoMobile from '../../assets/logoMobile.jpg';
import postOnSlack from 'src/core/postOnSlack';

const useStyles = makeStyles((theme: Theme) => ({
  paperModal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.up('xs')]: {
      width: 340,
    },
    [theme.breakpoints.up('sm')]: {
      width: 530,
    },
    [theme.breakpoints.up('lg')]: {
      width: 450,
    },
    boxShadow: theme.shadows[5],
    padding: theme.spacing(6),
    borderRadius: 10,
    backgroundColor: BACKGROUND_COLOR,
  },
  logo: {
    width: '6rem',
    height: '2rem',
  },
  customButton: {
    background: COLOR_PRIMARY_DARK,
    borderRadius: 5,
    border: 0,
    color: 'white',
    height: 40,
    padding: '0 15px',
    boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
    '&:hover': {
      background: COLOR_PRIMARY_LIGHT,
    },
    textTransform: 'capitalize',
  },
}));

const AirbnbAuthModal = ({ airbnbAuthModalOpen, setAirbnbAuthModalOpen, airbnbLoggedIn, user }) => {
  const classes = useStyles();

  const installChromeExtension = async () => {
    const hasUserCheckedOutVideoTutorial =
      localStorage.getItem('install-chrome-extension-btn-clicked') === 'true';
    if (!hasUserCheckedOutVideoTutorial) {
      try {
        const returnedData = await postOnSlack(
          'dynamic-pricing-monitor',
          `${user.email} tried to install Chrome Extension.\n`
        );
        if (returnedData) {
          window.localStorage.setItem('install-chrome-extension-btn-clicked', 'true');
        }
      } catch (err) {
        console.log(err);
      }
    }

    const airbticsChromeExtensionURL =
      'https://chrome.google.com/webstore/detail/airbtics-connect-your-air/njlfnmgcldledoooknioodhhcjmanmil/';
    let clickableLink: HTMLAnchorElement = document.createElement('a');
    clickableLink.href = airbticsChromeExtensionURL;
    clickableLink.target = '_blank';
    document.body.appendChild(clickableLink);
    clickableLink.click();
    if (clickableLink && clickableLink.nodeType && clickableLink.nodeType === Node.ELEMENT_NODE) {
      document.body.removeChild(clickableLink);
    }
  };

  const handleVideoTutorialLinkClick = async () => {
    const hasUserCheckedOutVideoTutorial =
      localStorage.getItem('airbnb-auth-video-tutorial-link-clicked') === 'true';
    if (!hasUserCheckedOutVideoTutorial) {
      try {
        const returnedData = await postOnSlack(
          'dynamic-pricing-monitor',
          `${user.email} checked out Video Tutorial.\n`
        );
        if (returnedData) {
          window.localStorage.setItem('airbnb-auth-video-tutorial-link-clicked', 'true');
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  return (
    <Modal
      open={!airbnbLoggedIn && airbnbAuthModalOpen}
      onClose={() => setAirbnbAuthModalOpen(false)}
      aria-labelledby="sunscription-modal"
      aria-describedby="subscription-and-payment-details"
    >
      <Grid container direction="column" alignItems="center" justify="center">
        <div className={`${classes.paperModal} modal-custom`}>
          <Grid container direction="column" alignItems="center" justify="center" spacing={4}>
            <Grid
              item
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              xs={12}
              spacing={2}
            >
              <Grid item>
                <img src={airbnb} alt="Airbnb" className={classes.logo} />
              </Grid>
              <Grid item>
                <SyncAltIcon style={{ color: DARK_GREY }} />
              </Grid>
              <Grid item>
                <img src={logoMobile} alt="Airbnb" className={classes.logo} />
              </Grid>
            </Grid>

            <Grid item>
              <Typography>
                Use <span style={{ fontWeight: 'bold' }}>Airbtics for Chrome</span> browser
                extension to connect Airbtics account to Airbnb.
                <br />
                <br />
                You need to be on <span style={{ fontWeight: 'bold' }}>
                  a laptop or a computer
                </span>{' '}
                and use one of these browsers -{' '}
                <span style={{ fontWeight: 'bold' }}>Chrome/Edge/Brave</span>.
              </Typography>
            </Grid>

            <Grid item>
              <Link
                href="https://youtu.be/I1ZdXUWCBdI"
                target="_blank"
                onClick={handleVideoTutorialLinkClick}
              >
                <Grid container direction="row" justify="space-between" alignItems="center">
                  <PlayCircleFilledIcon style={{ marginRight: '5px' }} />
                  <Typography>Video tutorial: Connect to Airbnb</Typography>
                </Grid>
              </Link>
            </Grid>

            <Grid item>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.customButton}
                onClick={installChromeExtension}
              >
                Install Chrome Extension
              </Button>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Modal>
  );
};

export default AirbnbAuthModal;
